module.exports = __webpack_public_path__ + "static/playstore-logo-e2684331172443722b53987995c0dbe0.svg";